import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { bucketDataWithId, sortBuckets } from "../../../lib/utils"

class ManageFinancierBatch extends React.Component {

  componentDidMount() {
    const { params: { id }, setCurrentId, reloadFinancierBatch, loadBuckets } = this.props
    setCurrentId(id)
    reloadFinancierBatch(id)
    loadBuckets()
  }

  render() {
    const { financierBatch, callback, setFinancierBatch, reloadFinancierBatch,
      removeFinancierBatch, buckets } = this.props
    return financierBatch
      ? callback(financierBatch, setFinancierBatch, reloadFinancierBatch, removeFinancierBatch, buckets) 
      : <p>Loading ..</p>
  }
}

ManageFinancierBatch.propTypes = {
  financierBatch: PropTypes.object,
  setCurrentId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {

  const financierBatch = DckSelectors.selectItemById(state, ItemTypes.FinancierBatch, ownProps.params.id)

  let bucks = DckSelectors.selectAllItems(state, ItemTypes.FinancierBucket)
  bucks = bucks.filter(({ closed }) => !closed)
  sortBuckets(bucks)

  const buckets = bucketDataWithId(bucks)

  return { financierBatch, buckets }
},

mapDispatchToProps = dispatch => ({

  setCurrentId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.FinancierBatch, id)),

  setFinancierBatch: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.FinancierBatch, id, data)),

  reloadFinancierBatch: id => dispatch(DckActionCreators.itemReload(ItemTypes.FinancierBatch, id)),

  removeFinancierBatch: id => dispatch(DckActionCreators.itemRemove(ItemTypes.FinancierBatch, id)),

  loadBuckets: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.FinancierBucket)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageFinancierBatch)



// WEBPACK FOOTER //
// ./src/components/Financiers/Batches/ManageItem.js